module.exports = __webpack_public_path__ + "img/ercode.efe33127.jpg";